var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-delivery"},[_c('div',{staticClass:"row"},[_c('form',{staticClass:"col s12"},[_c('phone'),_c('delivery-address'),_c('mail'),_c('date-time')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }